function isIOS(){
    return (
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0)
    )
    && !window.MSStream;
}

export { isIOS };